import { createActionTypes } from "@helpers/redux-helpers";

export const forgotPasswordSendEmailActionTypes = createActionTypes(
  "forgotPassword/sendEmail",
);

export const forgotPasswordRestoreActionTypes = createActionTypes(
  "forgotPassword/restore",
);

export const forgotPasswordActionTypes = createActionTypes("forgotPassword");

export const forgotPasswordModalType = "forgotPassword/modal";
